
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
 Require all svg in sprite folder to make a sprite
 - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

function requireAll(r) {
  r.keys().forEach(r)
}
requireAll(require.context('../svg/sprite/', true, /\.svg$/))

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
 JS
 - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */



import './accessibility'
import './alert'
import './animated'
import './bg'

import './header'
import './banner'
import './lang'
import './search'
import './filters'
import './node-form'
import './modal'
import './inputmask'

import './stats-counter'
import './smooth-scroll'

import './node--home'
import './node--observatory'
import './node--meeting'
import './node--adjudicator'
import './node--instance'

import './paragraph--galerie'
